
<template>
    <div class="w-100">
        <b-card no-body class="mb-1" v-for="(historyEntry, index) in entityHistory" :key="index">
            <b-card-header header-tag="header" class="d-flex justify-content-between align-items-center border-bottom-0">
                <div class="flex-grow-1">{{ historyEntry.action.displayName }} by {{ historyEntry.actionByUserAccount }}</div>
                <div class="mr-2">at {{ toDisplayString(historyEntry.actionDateTimeUTC, { type: 'datetime' }) }}</div>
                <b-button v-b-toggle="'history-collapse-' + index" variant="outline-secondary" size="sm">
                    <i class="fas fa-chevron-down when-closed"></i><i class="fas fa-chevron-up when-open"></i>
                </b-button>
            </b-card-header>
            <b-collapse :id="'history-collapse-' + index">
                <b-list-group flush>
                    <b-list-group-item v-for="(propertyEntry, index) in historyEntry.propertyHistory" :key="index">
                        <div class="font-weight-bold">{{ propertyEntry.propertyName }}:</div>
                        <div v-if="historyEntry.action.stringValue == 'Modified'">from</div>
                        <div class="ml-2 px-2 border rounded" v-if="historyEntry.action.stringValue == 'Modified'" style="white-space: pre-line !important;">
                        {{ propertyEntry.oldValue }}</div>
                        <div v-if="historyEntry.action.stringValue == 'Modified'">to</div>
                        <div class="ml-2 px-2 border rounded" style="white-space: pre-line !important;">{{ propertyEntry.newValue }}</div>
                    </b-list-group-item>
                </b-list-group>
            </b-collapse>
        </b-card>
    </div>
</template>

<script>
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';
    import axios from 'axios';
    
    import DisplayFormatMixin from '../mixins/DisplayFormatMixin';
    import ErrorsMixin from '../mixins/ErrorsMixin';
    
    Vue.use(BootstrapVue);
    
    export default {
        name: 'EntityHistoryList',
        mixins: [ErrorsMixin, DisplayFormatMixin],
        props: {
            entityTypeName: {
                type: String,
                default: null
            },
            entityId: {
                type: String,
                default: null
            }
        },
        watch: {
            entityTypeName: function () {
                this.loadEntityHistory();
            },
            entityId: function () {
                this.loadEntityHistory();
            }
        },
        data: function () {
            return {
                entityHistory: null
            };
        },
        methods: {
            loadEntityHistory: function () {
                if (this.entityTypeName && this.entityId) {
                    var url = this.$urlHelper.getApiUrl("history", "list", [this.entityTypeName, this.entityId]);
                    axios
                        .get(url)
                        .then(response => {
                            this.entityHistory = response.data;
                        })
                        .catch(ex => {
                            var currentErrors = this.handleAxiosException(ex);
                            this.showErrorsToast(currentErrors);
                        });
                }
            }
        },
        mounted: function () {
            this.loadEntityHistory();
        }
    }
</script>

<style scoped>
    button.collapsed > .when-open,
    button.not-collapsed > .when-closed {
        display: none;
    }
</style>
